import { Button, Group, Paper, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type PageFilterBannerProps = {
  message: string;
  onClear: () => void;
};

export function PageFilterBanner({ message, onClear }: PageFilterBannerProps) {
  const { t } = useTranslation();
  return (
    <Paper withBorder p="sm" mb="md" radius="md">
      <Group position="apart">
        <Text size="sm">{message}</Text>
        <Button variant="subtle" size="xs" onClick={onClear}>
          {t('opportunity.filters.clearFilters')}
        </Button>
      </Group>
    </Paper>
  );
}
